export default __webpack_public_path__ + "static/media/dia11.98796ba0.png";